import React, { useState } from 'react'
import { Box, Button } from '@elparking/components'
import { RentalCarEvents, trackTealiumEvent } from 'commons/js/services/analytics'
import { RENTAL_CAR_CLICK_TO_CALL_INFO } from 'commons/js/constants'
import Phone from 'rental-car-contract/js/components/Icons/Phone'
import { FormattedMessage } from 'react-intl'
import ClickToCallModal from 'rental-car-contract/js/components/Modals/ClickToCallModal'
import useOnCloseModalAnalyticEvent from 'commons/js/hooks/useOnCloseModalAnalyticEvent'
const ClickToCall = () => {
    const [showModal, setShowModal] = useState(false)

    useOnCloseModalAnalyticEvent(showModal, RentalCarEvents.showLandingView)

    const onClickC2CButton = () => {
        setShowModal(true)
        trackTealiumEvent(RentalCarEvents.clickC2Clink('landing'))
    }
    const handleOnLoadC2CModal = () => {
        trackTealiumEvent(RentalCarEvents.showC2CModal('landing'))
    }
    return <Box flexDirection='column' width='100%'>
        <ClickToCallModal
          isShown={showModal}
          onClose={() => setShowModal(false)}
          modalType={RENTAL_CAR_CLICK_TO_CALL_INFO}
          onShowPrivacyModal={() => setShowModal(false)}
          onLoad={handleOnLoadC2CModal}
        />
        <Box mt='2em'>
            <Button.bordered color='darkMain60' width='100%' padding='0 8px' fontSize='small' fontWeight='medium' backgroundColor='transparent' onClick={() => onClickC2CButton()}>
                <Phone color='darkMain60' height='12px' /><FormattedMessage defaultMessage='Te llamamos gratis' />
            </Button.bordered>
        </Box>
    </Box>
}

export default ClickToCall
